import './casesList.scss'
import { useQuery } from 'react-query'
import api  from "../../services/api";
import { Link } from 'react-router-dom';

const fetchCases = async () => {
  const res = await api.get(`/api/osint/case/`)
  return res.data.results
}

const CasesList = () => {
    const {
        data: cases,
        isLoading,
        error,
    } = useQuery("cases", fetchCases)
    
    if (isLoading) return <div>Loading...</div>
    if (error) return <div>Error: {error.message}</div>
    
    return (
        <div className="casesList">
        <span>Latest Cases</span>
        {cases.map((_case, index) => (
            <div key={index} className="case">
             <Link to={`/case/${_case.id}`}>
             <div className="caseInfo">
                <img
                  src="/images/case_default_cover.png"
                  alt=""
                />
                <span>{_case.name}</span>
              </div>
              </Link>
            </div>
          ))}
        </div>
    )
    }

export default CasesList